@import "~/styles/v1/_variables.scss";
@import "~/styles/v1/_spacing.scss";

.FlyoverFooter {
  border-top: $border-standard;
  padding: $size-XS;
}
